// Deprecated = Do not show in create dialog.

export const FinancialInstrumentsEnum = Object.assign({
  BOND_FULL: 'bond-full', // Deprecated
  BOND_WIB: 'bond-wib', // Deprecated
  BOND_PRIIP: 'bond-priip', // Deprecated
  BOND_PP: 'bond-pp', // Deprecated
  LOAN_2A: 'purchase-of-claims-VermgA2a', // Deprecated
  LOAN_2A3A: 'subordinated-loan-VermgA2-3a',
  LOAN_ECSP: 'loan-ecsp',
  SILENTPART_2A3A: 'silentpart-VermgA2-3a', // Deprecated
});

Object.freeze(FinancialInstrumentsEnum);

export const LoanFinancialInstrumentsEnum = [
  FinancialInstrumentsEnum.LOAN_2A,
  FinancialInstrumentsEnum.LOAN_2A3A,
  FinancialInstrumentsEnum.LOAN_ECSP,
  FinancialInstrumentsEnum.SILENTPART_2A3A,
];

export const DeprecatedFinancialInstruments = [
  FinancialInstrumentsEnum.BOND_FULL,
  FinancialInstrumentsEnum.BOND_WIB,
  FinancialInstrumentsEnum.BOND_PRIIP,

  FinancialInstrumentsEnum.BOND_PP,
  FinancialInstrumentsEnum.LOAN_2A,
  FinancialInstrumentsEnum.SILENTPART_2A3A,
];



// WEBPACK FOOTER //
// ./src/enum/financialProducts/FinancialInstruments.js